import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveFileArchiveCommand extends CommandBase {
    value: string;

    constructor(value: string) {
        super();
        this.value = value;
    }

    execute(data: RemoteConstantsModel): boolean {
        const index = data.archive.findIndex(f => f.fileName === this.value);
        if (index < 0) {
            return false;
        }

        data.archive.splice(index, 1);
        return true;
    }
}